import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';
import Home from './pages/Home/Home';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import GisDashboard from './pages/Dashboard/GisDashboard';
import MisDashboard from './pages/Dashboard/MisDashboard';
import Activities from './pages/Dashboard/Activities';
import Security from './pages/Dashboard/Security';
import DataManagement from './pages/Dashboard/DataManagement';
import ChatBoat from './pages/Dashboard/ChatBoat';
import Settings from './pages/Dashboard/Settings';
import CitizenLogin from './pages/CitizenLogin';
import SingUp from './pages/SingUp';
import AboutUs from './pages/Home/AboutUs';
import ChatHistory from './componets/ChatHistory';
import GraphDashboard from './pages/graph-dashboard/GraphDashboard';
import Enp from './pages/Home/Enp';
// import LinkDashboard from './pages/graph-dashboard/LinkDashboard';
// import LinkDashboard from './pages/Dashboard/GisToolsDeshboard'
import LinkDashboard from './pages/Dashboard/DBTools'
import ChangePassword from './pages/Dashboard/ChangePassword';
import SCADAOffline from "./pages/GisTools/SCADAOffline";
import SCADALive from "./pages/GisTools/SCADALive";
import SCADA from "./pages/GisTools/SCADA";
import ScadaChart from "./pages/GisTools/ScadaChart";
import MAPLayersAll from "./pages/GisTools/MAPLayersAll";
import MAPLayersUjjain from "./pages/GisTools/MapLayerUjjain";
import MapPointDist from "./pages/GisTools/MapPointDist";
import ABPAS_MPGARUD from './pages/Home/ABPAS_MPGARUD';
import ABPASSValidation from './pages/GisTools/ABPASSValidation';
import ABPASSIntrigation from './pages/GisTools/ABPASSIntrigation';
import FloodsSystem from './pages/GisTools/FloodsSystem';
import ABPASSVHousingBoard from './pages/GisTools/ABPASSVHousingBoard';
import SCADAWTP from './pages/GisTools/SCADAWTP';
import SCADAWTPDetails from "./pages/GisTools/SCADAWTPDetails";
import SCADAWTPDetailsALL from "./pages/GisTools/SCADAWTPDetailsALL";
import MapLayerUjjain from "./pages/GisTools/MapLayerUjjain";
//21MAY
import PropertyInfo from "./pages/GisTools/PropertyInfo";
import IdentifiedProperty from "./pages/GisTools/IdentifiedProperty";
import MapNewProperty2 from "./pages/GisTools/MapNewProperty2";
import PropertyChangeMap2 from "./pages/GisTools/PropertyChangeMap2";
import PropertyChangeMap3 from "./pages/GisTools/PropertyChangeMap3";
import KMLAnalysisComponent from "./pages/GisTools/KMLAnalysisComponent";
import GisQueryAnalysis from "./pages/GisTools/GisQueryAnalysis";
import SCADAHome from "./pages/GisTools/SCADAHome";
import ABPass from "./pages/GisTools/ABPass";
import BufferTool from "./pages/GisTools/BufferTool";
import SCADAWTPDashboard from "./pages/GisTools/SCADAWTP";
import DashboardAdmin from './pages/Dashboard/DashboardAdmin';
import ScadawtpRoute from './pages/GisTools/ScadawtpRoute';
import WTPReports from './pages/GisTools/SCADA_WTPRTP';
import STPReports from './pages/GisTools/SCADA_STPRTP';
// import ALLLayers from "./pages/GisTools/ALLLayers";

function App() {
    return (
        <>

            <Router>
                <Routes>
                    {/* Home Pages */}
                    <Route element={<MainLayout />}>
                        <Route path="/" element={<Home />} />
                    </Route>

                    {/* Dashboard (Protected Routes) */}
                    <Route element={<DashboardLayout />}>
                        <Route path="/dashboard" element={<GisDashboard />} />
                        <Route path="/misdashboard" element={<MisDashboard />} />
                        <Route path="/link-dashboard" element={<LinkDashboard />} />
                        <Route path="/activities" element={<Activities />} />
                        {/* <Route path="/datamanagement" element={<DataManagement />} /> */}
                         <Route path="/datamanagement" element={<DashboardAdmin />} />
                        <Route path="/security" element={<Security />} />
                        <Route path="/user-chatbot" element={<ChatBoat />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/chat-history" element={<ChatHistory />} />
                        <Route path="/graph-dashboard" element={<GraphDashboard />} />
                        <Route path="/change-password" element={<ChangePassword />} />
                        <Route path="/scadalive" element={<SCADALive />} />
                        <Route path="/scadaoffline" element={<SCADAOffline />} />
                        <Route path="/scada" element={<SCADA />} />
                        <Route path="/scadachart" element={<ScadaChart />} />
                        <Route path="/maplayersall" element={<MAPLayersAll />} />
                        <Route path="/maplayersujjain" element={<MAPLayersUjjain />} />
                        <Route path="/mappointdist" element={<MapPointDist />} />
                        <Route path="/abpass-validation" element={<ABPASSValidation />} />
                        <Route path="/abpass-intrigation" element={<ABPASSIntrigation />} />
                        <Route path="/floods-system" element={<FloodsSystem />} />
                        <Route path="/abpass-housing" element={<ABPASSVHousingBoard />} />
                        <Route path="/scada-wtp" element={<SCADAWTP />} />

                        {/* New route */}
                        <Route path="/PropertyInfo" element={<PropertyInfo />} />
                        <Route path="/IdentifiedProperty" element={<IdentifiedProperty />} />
                        <Route path="/MapNewProperty2" element={<MapNewProperty2 />} />
                        <Route path="/PropertyChangeMap2" element={<PropertyChangeMap2 />} />
                        <Route path="/PropertyChangeMap3" element={<PropertyChangeMap3 />} />
                        <Route path="/KMLAnalysisComponent" element={<KMLAnalysisComponent />} />
                        <Route path="/GisQueryAnalysis" element={<GisQueryAnalysis />} />
                        <Route path="/SCADAHome" element={<SCADAHome />} />
                        <Route path="/wtp-reports" element={<WTPReports />} />
                        <Route path="/stp-reports" element={<STPReports />} />
                        <Route path="/ABPass" element={<ABPass />} />
                        <Route path="/BufferTool" element={<BufferTool />} />
                        <Route path="/SCADAWTPDashboard" element={<SCADAWTPDashboard />} />
                        <Route path="/scada-wtp-details/:intakeId" element={<SCADAWTPDetails />} />
                        {/* <Route path="/ALLLayers" element={<ALLLayers />} /> */}
                    </Route>

                    {/* Login Page */}
                    <Route path="/citizen" element={<CitizenLogin />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/singup" element={<SingUp />} />
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/enp" element={<Enp />} />
                    <Route path="/abpas-mapgarud" element={<ABPAS_MPGARUD />} />
                    <Route path="/SCADAWTPDashboard" element={<SCADAWTPDashboard />} />
                    <Route path="/SCADAWTPDetailsALL" element={<SCADAWTPDetailsALL />} />
                    <Route path="/MapLayerUjjain" element={<MapLayerUjjain />} />
                    <Route path="/scadawtp-route" element={<ScadawtpRoute />} />
                    <Route path="/scadawtp" element={<ScadawtpRoute />} />
                    <Route
                        path="/flood-simulation"
                        element={
                            <iframe
                                src={`${process.env.PUBLIC_URL}/FloodSimulation.html`}
                                title="Flood Impact Simulation Dashboard"
                                style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
                            />
                        }
                    />
                    {/* 404 Not Found */}
                    <Route path="" element={<NotFound />} />

                </Routes>
            </Router>
        </>
    );
}


export default App;
